module.exports = __webpack_public_path__ + "static/fonts/Material-Design-Iconic-Font.a4d3112.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vendor/mdi-font/fonts/Material-Design-Iconic-Font.woff2?v=2.2.0
// module id = apmB
// module chunks = 2